import { FC, JSX, useMemo } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mediumDesktop, desktop } from 'helpers/utils/screensizes';
import { ContentSliderProps, ContentSliderSlideProps } from '../../content-slider';
import Wrapper from 'components/HOC/wrapper';
import CTATile from './tile';
import dynamic from 'next/dynamic';
import { useParams, usePathname } from 'next/navigation';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import { localeMapping } from 'helpers/constants/localeMapping';
const Markdown = dynamic(() => import('../../../organisms/markdown'));
const TilesMultipleCTA: FC<ContentSliderProps> = ({ data }) => {
  const { locale } = useParams();
  const localeKey = localeMapping[locale];

  
  const [isDesktopSize] = useMediaQuery(desktop);
  const currentURL = usePathname();
  const isContactUsPage = currentURL.includes('/contact');
  const slidesElement = useMemo(
    () =>
      data?.global_card?.map(
        (slide: JSX.IntrinsicAttributes & ContentSliderSlideProps, index: string | number | null | undefined) => (
          <CTATile key={index} {...slide} />
        ),
      ),
    [data?.card_header_section],
  );


  return (
    <>
    {/* {isContactUsPage && (
        <div className="hidden px-24 pb-8 pt-16 md:block md:px-12 lg:px-32 xl:px-44 2xl:px-64">
          <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
            <Link link={'/'}>
              <HomeIcon className="mt-6 w-20" />
            </Link>
            <span className="text-12 font-normal leading-4 text-[#666]">
              Contact
            </span>
          </Breadcrumb>
        </div>
      )} */}

      {/* We are showing and hiding Experience centre based on Country.
      If Country is NewZealand then we are hiding Experience Centre and if country is Australia then we are showing it */}
        {localeKey !== 'en-NZ' && localeKey !== 'en-AU' ? (
          <div className="our-product-container">
            <Wrapper clearDefaultStyles className={isContactUsPage?'px-24 3xl:px-0 2xl:px-80 xl:px-60 md:px-28 lg:px-48 pb-48 2xl:pb-80':"px-24 pb-48 lg:px-48 md:px-28 xl:pl-60 pt-48 xl:pt-60 lg:pt-60 2xl:pt-120 3xl:px-0 2xl:px-80 xl:pb-60 2xl:pb-120"}>
              <>
                  {data?.header?.section_title && (
                    <Typography
                      className={`${isContactUsPage ? 'pt-24 lg:pt-32 xl:mb-50 mb-24 text-left text-32 2xl:text-48' : 'mb-24 text-center md:text-left xl:text-32 text-32'} font-medium xl:leading-[2rem] leading-[3.25rem] text-[#090909] xl:text-32 2xl:text-48`}
                      as="h3"
                    >
                      {data?.header?.section_title}
                    </Typography>
                  )}
                  {data?.header?.section_description && !isContactUsPage && (
                    <Markdown
                      markdown={data?.header?.section_description}
                      className="pb-30 xl:pb-20 text-center xl:text-16 md:text-18 text-20 2xl:text-20 font-normal leading-8 text-[#333] xl:w-[75%] 2xl:w-[55%] md:text-left"
                    />
                  )}

                {isDesktopSize ? (
                  <div className="flex w-full gap-24">{slidesElement}</div>
                ) : (
                  <div className="relative flex w-full flex-col gap-32">{slidesElement}</div>
                )}
              </>        
            </Wrapper>
          </div>
        ) :
          <div className='pb-80'></div>
        }
    </>
  );
};
export default TilesMultipleCTA;